module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_answer-e6c650347426eef97cf8cbe201c67364.svg";